(() => {
  'use strict';
  if (window.__hmLeadMeasurement) return;
  const element = document.getElementById('hm-measurement-config');
  if (!element) return;
  let config;
  try { config = JSON.parse(element.textContent); } catch { return; }
  if (!/^G-[A-Z0-9]+$/.test(config.measurementId || '')) return;
  window.__hmLeadMeasurement = true;
  let ready = false;
  const clicked = new WeakMap();
  const pendingKey = 'hm-lead-pending-v1';
  const sentKey = 'hm-lead-sent-v1';
  const pagePath = window.location.pathname;
  let decodedPath = pagePath;
  try { decodedPath = decodeURI(pagePath); } catch {}
  const cleanPath = decodedPath.replace(/^\/he(?=\/|$)/, '') || '/';
  const publicPage = cleanPath === '/' || /^\/(products|collections|pages)\//.test(cleanPath);
  if (!publicPage) return;
  const pageGroup = cleanPath === '/' ? 'machine_selection'
    : cleanPath === '/collections/מכשירי-אולטרסאונד-יד-2' ? 'used_ultrasound'
    : cleanPath === '/collections/שירות-מכשירי-אולטרסאונד' ? 'machine_repair'
    : cleanPath === '/collections/תיקון-מתמרים' ? 'probe_repair'
    : cleanPath.startsWith('/products/') ? 'product'
    : cleanPath === '/pages/contact' ? 'contact'
    : ['/pages/how-to-choose-ultrasound-machine', '/pages/new-vs-used-ultrasound'].includes(cleanPath) ? 'buying_guide'
    : 'other_public';
  const allowed = () => Boolean(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.());
  const get = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const put = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch {} };
  const emit = (name, channel) => {
    if (!ready || !allowed()) return false;
    if (typeof window.gtag !== 'function') return false;
    window.gtag('event', name, {
      send_to: config.measurementId,
      contact_channel: channel,
      page_group: pageGroup,
      lead_page: pagePath,
      language: config.language,
      page_location: window.location.origin + pagePath,
      page_referrer: '',
      transport_type: 'beacon',
      ...(config.debug ? { debug_mode: true } : {})
    });
    return true;
  };
  const success = () => {
    if (!document.querySelector('#ContactForm [data-hm-contact-success="true"]')) return;
    const token = get(pendingKey);
    if (!token || get(sentKey) === token) return;
    const submittedAt = parseInt(token.split('-')[0], 36);
    if (!Number.isFinite(submittedAt) || submittedAt > Date.now() || Date.now() - submittedAt > 1800000) { remove(pendingKey); return; }
    if (emit('generate_lead', 'contact_form')) {
      put(sentKey, token);
      remove(pendingKey);
    }
  };
  const initialise = () => {
    if (!allowed()) return;
    if (!ready) {
      window.dataLayer = window.dataLayer || [];
      const configured = window.dataLayer.some(entry => entry?.[0] === 'config' && entry[1] === config.measurementId);
      if (typeof window.gtag !== 'function') {
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag('js', new Date());
      }
      if (!configured) window.gtag('config', config.measurementId, {
        send_page_view: false,
        allow_google_signals: false,
        allow_ad_personalization_signals: false
      });
      const existing = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
      if (!existing) {
        const tag = document.createElement('script');
        tag.async = true;
        tag.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(config.measurementId);
        document.head.appendChild(tag);
      }
      ready = true;
    }
    success();
  };
  const track = (node, type) => {
    if (!allowed()) return;
    initialise();
    const now = Date.now();
    if (clicked.has(node) && now - clicked.get(node) < 1000) return;
    if (emit(type, type === 'phone_click' ? 'phone' : 'whatsapp')) clicked.set(node, now);
  };
  const widgetIntent = node => {
    const widget = node?.closest?.('.whatsapp-chat-input');
    const input = widget?.querySelector('.text-input');
    if (input?.value?.trim() && /^\d{8,15}$/.test(widget.dataset.waNumber || '')) track(input, 'whatsapp_click');
  };
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && !event.isComposing && event.target?.matches?.('.whatsapp-chat-input .text-input')) widgetIntent(event.target);
  }, true);
  document.addEventListener('click', event => {
    if (event.target?.closest?.('.whatsapp-chat-input .attach-btn')) { widgetIntent(event.target); return; }
    const direct = event.target?.closest?.('.whatsapp-button[data-direct-mode="true"]');
    if (direct) { track(direct, 'whatsapp_click'); return; }
    const anchor = event.target?.closest?.('a[href]');
    if (!anchor || !allowed()) return;
    const href = anchor.getAttribute('href');
    let type = '';
    if (/^tel:/i.test(href)) type = 'phone_click';
    else {
      try {
        const url = new URL(href, window.location.origin);
        if (['https:', 'http:'].includes(url.protocol) &&
          ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) type = 'whatsapp_click';
      } catch {}
    }
    if (!type) return;
    track(anchor, type);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target?.id !== 'ContactForm' || !allowed()) return;
    put(pendingKey, Date.now().toString(36) + '-' + Math.random().toString(36).slice(2));
  }, true);
  document.addEventListener('visitorConsentCollected', initialise);
  if (window.Shopify?.customerPrivacy) initialise();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => { if (!error) initialise(); });
  }
})();
